const initialState = {
  bcf: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BCF_SELECT":
      return {
        ...state,
        bcf: action.payload,
      };
    default:
      return state;
  }
}
